import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const AutoHero = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Auto Insurance",
    "serviceType": "Insurance",
    "category": "Auto Insurance",
    "provider": {
      "@type": "InsuranceAgency",
      "name": "Allen Insurance Agency",
      "areaServed": "Illinois"
    },
    "description": "Comprehensive auto insurance coverage including collision, liability, and full coverage options.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-purple-50">
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-fade-up space-y-6">
          <h1 className="text-4xl md:text-6xl font-bold text-primary-dark mb-6 tracking-tight">
            Auto Insurance Coverage
          </h1>
          <p className="text-lg md:text-xl text-neutral max-w-2xl mx-auto leading-relaxed">
            Protect yourself and your vehicle with comprehensive auto insurance coverage. Get a quote today and drive with confidence.
          </p>
        </div>
        <div className="text-center animate-fade-up">
          <Link to="/quote">
            <Button size="lg" className="bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300">
              Quick Quote
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};